import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77cb682d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pws-notification-card-container" }

import { Notifications } from '@/typings/notification';
import { inject, ref } from 'vue';
import NotificationCard from './NotificationCard.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const notifs = ref<Record<number, Notifications>>({});

function removeNotification(uuid: number) {
  delete notifs.value[uuid];
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $socket = inject('$socket') as any;
$socket.on('score_update', (notification: Notifications) => {
  const existingKeys = Object.keys(notifs.value) as unknown as Array<number>;
  if (existingKeys.length >= 5) {
    const min = Math.min(...existingKeys);
    removeNotification(min);
  }
  notifs.value[notification.sentAt] = notification;
});

function dismissAll() {
  notifs.value = {};
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifs.value, (notif, uuid) => {
      return (_openBlock(), _createBlock(NotificationCard, {
        key: notif.sentAt,
        uuid: uuid,
        notification: notif,
        onDismiss: removeNotification
      }, null, 8, ["uuid", "notification"]))
    }), 128)),
    (Object.keys(notifs.value).length > 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: dismissAll,
          class: "dismiss"
        }, " Dismiss all "))
      : _createCommentVNode("", true)
  ]))
}
}

})